/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * * `add` - add
 * * `remove` - remove
 */
export enum BulkUpdateTagsOperationEnum {
    ADD = 'add',
    REMOVE = 'remove',
}
